import React from 'react';
import styled from '@emotion/styled';
import Results, { ResultItem } from '../Symbols/Results';

const formatCurrency = amount => {
	return Math.round(amount).toLocaleString('cs') + ' Kč';
};

const Div = styled('div')`
	font-weight: bold;
	font-size: 18px;
	line-height: 26px;
	padding: 5px 10px;
`;

const ResultNumber = styled('span')`
	font-style: italic;
	text-align: right;
`;

export default function StyledResult({ hypoteka }) {
	return (
		<Results data-cy="result">
			<ResultItem name="Měsíční splátka hypotéky:">
				<ResultNumber>{formatCurrency(hypoteka.monthlyPayment)}</ResultNumber>
			</ResultItem>
			<ResultItem name="Minimální čistý měsíční příjem:">
				<ResultNumber>{formatCurrency(hypoteka.minIncome)}</ResultNumber>
			</ResultItem>
			<ResultItem name="Maximální možná výše hypotéky podle příjmu:">
				<ResultNumber>{formatCurrency(hypoteka.maxPrice)}</ResultNumber>
			</ResultItem>
			<ResultItem name="Potřebné vlastní zdroje pro hypotéku:">
				<ResultNumber>{formatCurrency(hypoteka.ownResources)}</ResultNumber>
			</ResultItem>
			<ResultItem name="Daň z nabytí nemovitosti:">
				<ResultNumber>{formatCurrency(hypoteka.tax)}</ResultNumber>
			</ResultItem>
			<Div data-cy="result-info">
				{hypoteka.entitlement
					? 'Při tomto nastavením parametrů na hypotéku dosáhnete.'
					: 'Při tomto nastavením parametrů na hypotéku nedosáhnete. Příčinou může být nízký měsíční příjem či míra zadlužení vůči čistému příjmu. Zkuste prodloužit například dobu splácení hypotéky.'}
			</Div>
		</Results>
	);
}
